import Link from "next/link";
import React, { useContext, useState, useTransition } from "react";
import helper from "../../lib/helper";
// import homepagelayoutModel from "../../models/homepagelayout.model";
import useSWR from "swr";
import Pagination from "../../components/Pagination";
import Heading from "../../components/Heading";
import Table from "../../components/Table";
import { useRouter } from "next/router";
import config from "../../lib/config";
import moment from "moment/moment";
import homepagelayoutModel from '../../models/pages.model'
const Page = function () {
    const [showLoader, setShowLoader] = useState(false);

    const router = useRouter();
    const queryParams = router.query;
    const { data: homepagelayoutData, mutate: reloadhomepagelayoutData, isLoading } = useSWR(
        queryParams || null,
        () => homepagelayoutModel.list(queryParams),
        config.swrConfig
    );

    const columns = [
        {
            Header: "Title",
            accessor: "title",
        },
        {
            Header: "Type",
            accessor: "type",
        },
        {
            Header: "Content Type",
            accessor: "content_type",
        },
        {
            Header: "Date",
            id: "created_at",
            Cell: ({ row }) => (
                <>
                    <div>
                    {helper.date.format(row.original.created_at)}
                    </div>
                </>
            )
            },
            {
                Header: "Actions",
                id: "action",
                Cell: ({ row }) => (
                    <>
                        <div className="btn-group btn-group-sm">
                            <Link
                                className="btn btn-primary"
                                href={`/pages/${row.original.id}/content`}
                            >
                                <i className="bi bi-eye"></i>
                            </Link>
                            <Link
                                className="btn btn-warning"
                                href={`/pages/${row.original.id}/edit`}
                            >
                                <i className="bi bi-pencil-square"></i>
                            </Link>
                            <button
                                className="btn btn-danger"
                                onClick={() => confirmDelete(row.original.id, row.original.title)}
                            >
                                <i className="bi bi-trash"></i>
                            </button>
                        </div>
                    </>
                ),
            },
    ];
    const confirmDelete = async (id, title) => {
        await helper.sweetalert
            .confirm(`confirm to delete ${title}`, "warning")
            .then(async (result) => {
                if (result.isConfirmed) {
                    setShowLoader(true);
                    await homepagelayoutModel.destroy(id).then((res) => {
                        reloadhomepagelayoutData();
                        helper.sweetalert.toast(`${title} deleted Successfully`);
                    });
                    setShowLoader(false);
                }
            });
    };

    return (
        <>
            <Heading title="Pages" >
                {console.log()}
                <Link className="btn btn-primary btn-sm" href="/pages/create">
                    <i className="bi bi-plus" />  Create
                </Link>
            </Heading>
            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">Pages-list</div>
                    <div className="table-responsive">
                        <Table columns={columns} data={homepagelayoutData?.data || []} />
                    </div>
                    <div className="card-footer">
                        <Pagination meta={homepagelayoutData?.meta} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
